<h4 translate="services.pointOfSale.title"></h4>

<div class="btn-bar">
  <button class="btn btn-primary" [appHasAnyRole]="[AppRoles.superAdmin]"
    (click)="createPointOfSale()"
    translate="services.pointOfSale.actions.add">
  </button>
</div>

<div class="table-responsive">
  <table class="table table-striped"
    [attr.aria-label]="'services.pointOfSale.title' | translate">
    <thead>
      <tr>
        <th scope="col" style="min-width:200px" translate="services.pointOfSale.table.posId"></th>
        <th scope="col" style="min-width:200px" translate="services.pointOfSale.table.name"></th>
        <th scope="col" style="min-width:300px" translate="services.pointOfSale.table.description"></th>
        <th scope="col" style="min-width:100px" [appHasAnyRole]="[AppRoles.superAdmin]"></th>
      </tr>
    </thead>

    <tbody>
      @if (pointsOfSale.length === 0) {
        <tr>
          <td>-</td>
          <td>-</td>
          <td>-</td>
          <td></td>
        </tr>
      }

      @for (pointOfSale of pointsOfSale; track pointOfSale) {
        <tr>
          <td>{{pointOfSale.posId}}</td>
          <td>{{pointOfSale['name' + crtLang.toUpperCase()]}}</td>
          <td>{{pointOfSale['description' + crtLang.toUpperCase()]}}</td>
          <td class="text-end" [appHasAnyRole]="[AppRoles.superAdmin]">
            <button class="btn btn-link btn-sm"
              (click)="updatePointOfSale(pointOfSale)"
              title="{{'common.tooltip.edit' | translate}}">
              <fa-icon [icon]="icons.edit"></fa-icon>
            </button>
            <button class="btn btn-link btn-sm" [appHasAnyRole]="[AppRoles.superAdmin]"
              (click)="deletePointOfSale(pointOfSale)"
              title="{{'common.tooltip.delete' | translate}}">
              <fa-icon [icon]="icons.delete"></fa-icon>
            </button>
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
